module.exports = __webpack_public_path__ + "static/media/buy-sec.8c1b9276.png";